import { useMemo } from 'react';
import { useAppDisplayModeContext } from '@archipro-design/aria';
import DetailsTab from './DetailsTab';
import InformationTab from './InformationTab';
import type Product from '../../type/product';

interface SpecificationsProps {
    data: Product;
}

const Specifications = ({ data }: SpecificationsProps) => {
    const { mobile } = useAppDisplayModeContext();
    const trackingPrefix = 'product';

    const tabItems = useMemo(() => {
        const { PerformanceDescription, ScopeOfUseDescription, LibraryTabs } =
            data;

        const sections = [];

        const specificationsTab = LibraryTabs.find(
            (tab) => tab.Title === 'Specifications' && tab.Content
        );

        const customTabsExcludingSpecs = LibraryTabs.filter(
            (tab) => tab.Title !== 'Specifications' && tab.Content
        );

        const showInformationTab = Boolean(
            specificationsTab ||
                PerformanceDescription ||
                ScopeOfUseDescription ||
                customTabsExcludingSpecs.length
        );

        const showDetailsTab = Boolean(
            data.Categories.length ||
                data.LibraryRange ||
                data.Brand ||
                data.Designer ||
                data.Year ||
                data.WarrantyDuration ||
                data.FacetOptions.length
        );

        if (showDetailsTab) {
            const detailsTab = {
                key: `${trackingPrefix}-tab-0`,
                title: 'Details',
                content: {
                    children: <DetailsTab data={data} />,
                    key: `${trackingPrefix}-content-0`,
                },
            };

            sections.push(detailsTab);
        }

        if (showInformationTab) {
            const infoTab = {
                key: `${trackingPrefix}-information-tab`,
                title: !mobile ? '' : 'Information',
                content: {
                    children: (
                        <InformationTab
                            data={{
                                SpecificationTab: specificationsTab,
                                PerformanceDescription,
                                ScopeOfUseDescription,
                                LibraryTabs: customTabsExcludingSpecs,
                            }}
                            professional={data.Professional}
                        />
                    ),
                    key: `${trackingPrefix}-information-content`,
                },
            };

            sections.push(infoTab);
        }

        return { sections };
    }, [data, mobile]);

    return (
        <div className="md:mt-16">
            {tabItems.sections.map((p, i) => (
                <div key={'product-spec-' + i} className="mt-15 md:mt-0">
                    <div className="mb-7.5 font-gt-america text-base font-medium uppercase leading-none text-gray-800 md:font-sans md:text-lg md:normal-case md:leading-[1.75] md:tracking-wide">
                        {String(p.title)}
                    </div>
                    <div key={p.key}>{p.content.children}</div>
                </div>
            ))}
        </div>
    );
};

export default Specifications;
